module.exports = __webpack_public_path__ + "static/img/417.e7817784.jpg";